module.exports = __webpack_public_path__ + "img/devmeetups.png.c2061aef.webp";